/** Shared hex → human-readable color name (used in plan + theme editors). */
export const getColorNameFromHex = (hex) => {
  const colors = {
    '#FF0000': 'Red', '#DC143C': 'Crimson', '#FF6347': 'Tomato', '#FF4500': 'Orange Red',
    '#FF69B4': 'Hot Pink', '#FF1493': 'Deep Pink', '#C71585': 'Medium Violet Red',
    '#FFA500': 'Orange', '#FF8C00': 'Dark Orange', '#FFD700': 'Gold', '#FFC107': 'Amber',
    '#FFFF00': 'Yellow', '#FFFFE0': 'Light Yellow', '#FFFACD': 'Lemon Chiffon',
    '#00FF00': 'Lime', '#32CD32': 'Lime Green', '#228B22': 'Forest Green', '#006400': 'Dark Green',
    '#90EE90': 'Light Green', '#98FB98': 'Pale Green', '#8FBC8F': 'Dark Sea Green',
    '#7CB342': 'Light Green', '#6B8E23': 'Olive Drab', '#556B2F': 'Dark Olive Green',
    '#0000FF': 'Blue', '#00BFFF': 'Deep Sky Blue', '#1E90FF': 'Dodger Blue',
    '#4169E1': 'Royal Blue', '#000080': 'Navy', '#6495ED': 'Cornflower Blue',
    '#87CEEB': 'Sky Blue', '#ADD8E6': 'Light Blue', '#00CED1': 'Dark Turquoise',
    '#00FFFF': 'Cyan', '#40E0D0': 'Turquoise', '#7FFFD4': 'Aquamarine',
    '#800080': 'Purple', '#8B008B': 'Dark Magenta', '#9400D3': 'Dark Violet',
    '#9932CC': 'Dark Orchid', '#BA55D3': 'Medium Orchid', '#DA70D6': 'Orchid',
    '#EE82EE': 'Violet', '#DDA0DD': 'Plum', '#E6E6FA': 'Lavender',
    '#FFC0CB': 'Pink', '#FFB6C1': 'Light Pink', '#DB7093': 'Pale Violet Red',
    '#8B4513': 'Saddle Brown', '#A0522D': 'Sienna', '#D2691E': 'Chocolate',
    '#CD853F': 'Peru', '#DEB887': 'Burlywood', '#F4A460': 'Sandy Brown',
    '#FFFFFF': 'White', '#F5F5F5': 'White Smoke', '#DCDCDC': 'Gainsboro',
    '#C0C0C0': 'Silver', '#A9A9A9': 'Dark Gray', '#808080': 'Gray',
    '#696969': 'Dim Gray', '#000000': 'Black', '#2F4F4F': 'Dark Slate Gray',
    '#FFFAF0': 'Floral White', '#FAEBD7': 'Antique White', '#FFF8DC': 'Cornsilk',
    '#FFFFF0': 'Ivory', '#F5F5DC': 'Beige', '#FAF0E6': 'Linen'
  };

  const hexUpper = String(hex || '').trim().toUpperCase();
  if (colors[hexUpper]) return colors[hexUpper];

  const hexToRgb = (h) => {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(h);
    return result
      ? { r: parseInt(result[1], 16), g: parseInt(result[2], 16), b: parseInt(result[3], 16) }
      : null;
  };

  const rgb = hexToRgb(hexUpper);
  if (!rgb) return 'Custom Color';

  let closestColor = 'Custom Color';
  let minDistance = Infinity;

  Object.entries(colors).forEach(([colorHex, colorName]) => {
    const colorRgb = hexToRgb(colorHex);
    if (colorRgb) {
      const distance = Math.sqrt(
        Math.pow(rgb.r - colorRgb.r, 2)
        + Math.pow(rgb.g - colorRgb.g, 2)
        + Math.pow(rgb.b - colorRgb.b, 2)
      );
      if (distance < minDistance) {
        minDistance = distance;
        closestColor = colorName;
      }
    }
  });

  return closestColor;
};

export const resolveColorLabel = (color) => {
  if (!color) return '';
  if (typeof color === 'string') {
    return /^#/.test(color.trim()) ? getColorNameFromHex(color) : color;
  }
  const name = String(color.name || '').trim();
  if (name) return name;
  return color.hex ? getColorNameFromHex(color.hex) : '';
};
